/// <reference path="../../../typings/tsd.d.ts" /> 

module warsApp.directives {
    export interface IApiGridSectionScope extends ng.IScope {
        model: ApiGridSectionModel;
        isConfigureMode: boolean;
        isEditMode: boolean;
        process: Wars.Domain.Model.Dtos.ProcessDto;
        processConfigurationId: string;
        manageSection: Wars.Domain.Model.ManageSection;
        hideSection:boolean;
    }

    export class ApiGridSection implements IDirective {
        public link($scope: IApiGridSectionScope,
            element: JQuery,
            attrs: ng.IAttributes) {
        }

        public templateUrl = './app/views/directives/manageForm/apiGridSection.html';
        public controller = ['$scope', 'formService', 'apiGridConfigurationService', ApiGridSectionController];
        public controllerAs = 'controller';
        public restrict: string = 'E';
        public scope: any = {
            isConfigureMode: "=",
            isEditMode: "=",
            process: "=",
            processConfigurationId: "=",
            manageSection: "=",
            hideSection:"="
        };
    }

    export class ApiGridSectionModel {
        public apiGridConfigurations: Wars.Domain.Model.ApiGridConfiguration[];

        constructor(private formService: services.FormService,
            private apiGridConfigurationService: Services.ApiGridConfigurationService, private processConfigurationId,
            public isConfigureMode: boolean, public manageSection: Wars.Domain.Model.ManageSection, private process: Wars.Domain.Model.Dtos.ProcessDto) {

            if (isConfigureMode) {
                apiGridConfigurationService.getApiGridConfigurations(processConfigurationId).then(apiGridConfigurations => {
                    this.apiGridConfigurations = apiGridConfigurations;
                });
            }
        }

        private apiGridConfigurationChanged() {
            this.formService.saveAllChanges();
        }
    }

    export class ApiGridSectionController {
        constructor(private scope: IApiGridSectionScope, private formService: services.FormService,
            private apiGridConfigurationService: services.ApiGridConfigurationService) {
            scope.model = new ApiGridSectionModel(formService,
                apiGridConfigurationService,
                scope.processConfigurationId,
                scope.isConfigureMode, scope.manageSection, scope.process);

        }
    }
}
warsApp.registerDirective('ApiGridSection', []);